export const CHANGE_REQUEST_FORM_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSdFV6M_cAKK1w2-W4N3_mLJKGmoA7UZZ6_BzIqwJjui9kMegg/viewform';
